const OPEN_NOTIFY = 'platfi-ui-app/NOTIFY/OPEN_NOTIFY';
const CLOSE_NOTIFY = 'platfi-ui-app/NOTIFY/CLOSE_NOTIFY';

export { CLOSE_NOTIFY, OPEN_NOTIFY };
